// extracted by mini-css-extract-plugin
module.exports = {"rzdyWrapper":"BookingWidget--rzdyWrapper--mbU0M","animatedBackground":"BookingWidget--animatedBackground--2a9qY","placeHolderShimmer":"BookingWidget--placeHolderShimmer--16lj8"};